import config from '../config';

/**
 * Adds data-automation-id to element for testing. It prevent's data automation ids from leaking to production
 */
export function qaProp(qa?: string, suffix?: string) {
  if (!qa || config.environment.isProd) return {};
  return { 'data-automation-id': suffix ? `${qa}${suffix}` : qa };
}
